const state = {
    threadUseInformationFields: [
        {
            key: "code",
            label: "牙板編號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "seriesNo",
            label: "牙板序號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "name",
            label: "牙板名稱",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "used_life",
            label: "累積使用壽命",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "standard_life",
            label: "標準壽命",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    threadUseInformationItem: [],
}
const getters = {
    get_threadUseInformationFields: state => {
        return state.threadUseInformationFields
    },
    get_threadUseInformationItem: state => {
        return state.threadUseInformationItem
    },
}
const actions = {
    set_threadUseInformationFields(context, array) {
        context.commit('SET_THREADUSEINFORMATIONFIELDS', array);
    },
    set_threadUseInformationItem(context, array) {
        context.commit('SET_THREADUSEINFORMATIONITEM', array);
    },
    clear_threadUseInformationItem(context) {
        context.commit('CLEAR_THREADUSEINFORMATIONITEM');
    },
}
const mutations = {
    SET_THREADUSEINFORMATIONFIELDS(state, array) {
        state.threadUseInformationFields = array;
    },
    SET_THREADUSEINFORMATIONITEM(state, array) {
        state.threadUseInformationItem = array;
    },
    CLEAR_THREADUSEINFORMATIONITEM(state) {
        state.threadUseInformationItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/threadUseInformation.js